'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'mug-saucer';
var width = 576;
var height = 512;
var aliases = ["coffee"];
var unicode = 'f0f4';
var svgPathData = 'M392 80l8 0 0 256-288 0 0-256 280 0zm56 144l0-144 8 0c39.8 0 72 32.2 72 72s-32.2 72-72 72l-8 0zm0 112l0-64 8 0c66.3 0 120-53.7 120-120S522.3 32 456 32l-392 0 0 352 384 0 0-48zM56 464l-24 0 0 48 448 0 0-48-424 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMugSaucer = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;